/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.attendance.attendance-triggers'},
});

const AttendanceTriggersItem = () => (
  <RouteLinkItem
    route="midas/settings/attendance/attendance-triggers"
    title={messages.title}
  />
);

export default AttendanceTriggersItem;
